/**
 * Discovery "search_type" toggles — must stay in sync with CubeFilterBuilder.parseDynamicCubeFilter.
 */
import { FILTER_CONFIG } from '../../../common/metadata/FilterConfig';

export const SEARCH_TYPE_FILTER_IDS = new Set(['LICENSES', 'REVIEWS', 'WEBSITES', 'PERMITS', 'PROJECTS']);

/**
 * Map of search-type filter id -> the literal value the cube's `search_type`
 * column expects. Sourced from each filter's `filterValue` in FilterConfig so
 * the submitted value stays editable in one place. Falls back to the id when a
 * filter has no `filterValue`, preserving the pre-map behavior.
 */
export const SEARCH_TYPE_VALUE_BY_ID = (() => {
    const map = {};
    (FILTER_CONFIG.groups || []).forEach((group) =>
        (group.subgroups || []).forEach((subgroup) =>
            (subgroup.filters || []).forEach((f) => {
                if (SEARCH_TYPE_FILTER_IDS.has(f.id)) {
                    map[f.id] = f.filterValue != null ? f.filterValue : f.id;
                }
            }),
        ),
    );
    // Guarantee every known id resolves, even if absent from the config.
    SEARCH_TYPE_FILTER_IDS.forEach((id) => {
        if (!(id in map)) map[id] = id;
    });
    return map;
})();
